module.exports = __webpack_public_path__ + "img/0927b5a0d9e9d11958e69ba69a98e2f0.png";